import utils from '../utils.js';

class InterceptorManager{use(fulfilled,rejected,options){this.handlers.push({fulfilled,rejected,synchronous:options?options.synchronous:false,runWhen:options?options.runWhen:null});return this.handlers.length-1}eject(id){if(this.handlers[id]){this.handlers[id]=null;}}clear(){if(this.handlers){this.handlers=[];}}forEach(fn){utils.forEach(this.handlers,function forEachHandler(h){if(h!==null){fn(h);}});}constructor(){this.handlers=[];}}

export { InterceptorManager as default };
//# sourceMappingURL=InterceptorManager.js.map
